// Define the title type based on the API schema
type TitleType = 
  | 'RESEARCHER'
  | 'PROJECT_MANAGER' 
  | 'PRINCIPAL_INVESTIGATOR'
  | 'DIRECTOR'
  | 'STUDENT'
  | 'TECH_TRANSFER_OFFICE'
  | 'OTHER'

// Define titles array with proper typing using 'as const satisfies'
export const TITLES = [
  'RESEARCHER',
  'PROJECT_MANAGER', 
  'PRINCIPAL_INVESTIGATOR',
  'DIRECTOR',
  'STUDENT',
  'TECH_TRANSFER_OFFICE',
  'OTHER',
] as const satisfies readonly TitleType[]

// Export the type for use in other files
export type Title = typeof TITLES[number]

// Helper function to format title for display
export const formatTitleForDisplay = (title: Title): string => {
  return title.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase())
}

// Helper function to get title options for forms
export const getTitleOptions = () => 
  TITLES.map(title => ({
    value: title,
    label: formatTitleForDisplay(title)
  }))
